module.exports = __webpack_public_path__ + "static/media/JS.89d2c97e.png";